import { formatNumber } from '@/shared/util/formatNumber'
import { useStyles } from './styles'
import { Icon } from '../icon'

type EarnedPoints = {
  points: number
}

export const EarnedPoints = (props: EarnedPoints) => {
  const { points } = props
  const { classes } = useStyles()

  return (
    <div className={classes.root}>
      <span>+{formatNumber(points)}</span>
      &nbsp;
      <Icon
        view="fist"
        style={{
          position: 'relative',
          height: '16px',
          width: '16px',
          top: '1px',
        }}
      />
    </div>
  )
}
